import HorizontalNavbar from "../components/MainNavs/HorizontalNavbar";
import { ThemeProvider } from "@mui/material";
import { theme } from "../styles/theme";
import { AuthContextProvider } from "../context/authContext";
import { msalInstance } from "../utils/msal";
import { MsalProvider } from "@azure/msal-react";
import { Outlet } from "react-router-dom";

export const GlobalOutlet = () => {
  return (
    <AuthContextProvider>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider theme={theme}>
          <Outlet />
        </ThemeProvider>
      </MsalProvider>
    </AuthContextProvider>
  );
};

export const Layout = () => {
  return (
    <>
      <HorizontalNavbar />
      <Outlet />

      {/* <Footer /> */}
    </>
  );
};
